// Module
var code = `<page-header model="navModel"></page-header>

<div class="page-container page-body">
	<h3 class="page-sub-heading">Hello {{greeting}}.</h3>

	<div class="modal-tagline p-b-2">
		<em>{{invitedBy}}</em> has invited you to join Grafana and the organization <span class="highlight-word">{{contextSrv.user.orgName}}</span><br>Please complete the following and choose a password to accept your invitation and continue:
	</div>

	<form name="inviteForm" class="login-form gf-form-group">
		<div class="gf-form">
			<span class="gf-form-label width-7">Email</span>
			<input type="email" name="email" class="gf-form-input max-width-21" required ng-model="formModel.email" placeholder="Email">
		</div>
		<div class="gf-form">
			<span class="gf-form-label width-7">Name</span>
			<input type="text" name="name" class="gf-form-input max-width-21" ng-model="formModel.name" placeholder="Name (optional)">
		</div>
		<div class="gf-form">
			<span class="gf-form-label width-7">Username</span>
			<input type="text" name="username" class="gf-form-input max-width-21" required ng-model="formModel.username" placeholder="Username">
		</div>
		<div class="gf-form">
			<span class="gf-form-label width-7">Password</span>
			<input type="password" name="password" class="gf-form-input max-width-21" required ng-model="formModel.password" id="inputPassword" placeholder="password">
		</div>

		<div class="gf-form-button-row">
			<button type="submit" class="btn btn-primary" ng-click="submit();" ng-disable="!inviteForm.\$valid">
				Sign Up
			</button>
		</div>
	</form>
</div>

<footer>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/partials/signup_invited.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;